import { Helmet } from 'react-helmet-async';

const seoData = {
  '/': {
    title: 'Dilling El | Energioptimering til erhverv | Roskilde',
    description: 'Dokumenterbar energioptimering til erhverv. Vi hjælper virksomheder med at reducere energiforbruget gennem LED-løsninger og intelligent lysstyring.',
    canonical: 'https://dillingel.dk/',
  },
  '/om-os': {
    title: 'Om Dilling El | Specialister i energioptimering',
    description: 'Hos Dilling El arbejder vi med energioptimering og intelligent belysning i erhvervsbygninger. 20+ års erfaring med dokumenterede energibesparelser.',
    canonical: 'https://dillingel.dk/om-os',
  },
  '/ydelser/energioptimering': {
    title: 'Energioptimering | LED-belysning til erhverv | Dilling El',
    description: 'Vi analyserer eksisterende belysningsinstallationer og implementerer energieffektive LED-løsninger til erhvervsbygninger med dokumenteret effekt.',
    canonical: 'https://dillingel.dk/ydelser/energioptimering',
  },
  '/ydelser/lysstyring': {
    title: 'Intelligent lysstyring | Sensorer og automatisering | Dilling El',
    description: 'Intelligent lysstyring tilpasser belysningen efter aktivitet og dagslys. Sensorer, zonestyring og automatisering til erhvervsbygninger.',
    canonical: 'https://dillingel.dk/ydelser/lysstyring',
  },
  '/ydelser/service': {
    title: 'Service & vedligehold | Driftssikre løsninger | Dilling El',
    description: 'Med en serviceaftale sikrer I stabil drift af jeres belysningsinstallationer. Planlagt vedligehold og hurtig respons ved driftsproblemer.',
    canonical: 'https://dillingel.dk/ydelser/service',
  },
  '/nybyg-og-renovering': {
    title: 'Nybyg & Renovering | Elinstallationer til erhverv | Dilling El',
    description: 'Komplette elinstallationer til nybyggeri og renovering. Kvalitet, koordinering og driftssikre løsninger til erhvervsbyggeri.',
    canonical: 'https://dillingel.dk/nybyg-og-renovering',
  },
  '/esg': {
    title: 'ESG & Dokumentation | Målbar energibesparelse | Dilling El',
    description: 'Dokumentation der kan bruges i praksis. Vi måler energiforbrug før og efter installation til ESG-rapportering og energiledelse.',
    canonical: 'https://dillingel.dk/esg',
  },
  '/ledige-stillinger': {
    title: 'Ledige stillinger | Karriere hos Dilling El',
    description: 'Se ledige stillinger hos Dilling El. Vi søger dygtige elektrikere og projektledere til vores team i Roskilde.',
    canonical: 'https://dillingel.dk/ledige-stillinger',
  },
  '/kontakt': {
    title: 'Kontakt Dilling El | Book et møde',
    description: 'Kontakt Dilling El for en uforpligtende samtale om energioptimering. Tlf: +45 46 46 12 34 | Email: info@dilling-el.dk',
    canonical: 'https://dillingel.dk/kontakt',
  },
};

export const SEOHead = ({ path }) => {
  const seo = seoData[path] || seoData['/'];
  
  return (
    <Helmet>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={seo.canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content="https://dillingel.dk/images/og-image.jpg" />
      <meta property="og:locale" content="da_DK" />
      <meta property="og:site_name" content="Dilling El ApS" />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={seo.canonical} />
      <meta property="twitter:title" content={seo.title} />
      <meta property="twitter:description" content={seo.description} />
      <meta property="twitter:image" content="https://dillingel.dk/images/og-image.jpg" />
    </Helmet>
  );
};

export default SEOHead;
